let _ = t => t,
  _t;
import { useCallback, useState } from 'react';
import { fullWidthCellClassName } from 'customer-data-properties/utils/fullWidthCellClassName';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapDiv = styledWithTheme.div(_t || (_t = _`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:has(
      .${0}, [data-classname~="${0}"]
    ) {
    width: 100%;
  }
  ${0}
`), fullWidthCellClassName, fullWidthCellClassName, ({
  $rightAligned
}) => $rightAligned ? 'text-align: right; width: 100%;' : '');
const TruncateDiv = ({
  rightAligned,
  children
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const handleMouseEnter = useCallback(({
    currentTarget
  }) => {
    setIsTruncated(currentTarget.scrollWidth > currentTarget.clientWidth);
  }, []);
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsx(View, {
    children: children
  }), [children]);
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: TooltipContent,
    disabled: !isTruncated,
    maxInlineSize: "500px",
    children: /*#__PURE__*/_jsx(NoWrapDiv, {
      "data-test-id": "truncated-object-label",
      onMouseEnter: handleMouseEnter,
      $rightAligned: rightAligned,
      children: children
    })
  });
};
export default TruncateDiv;